export function numericRent(value: unknown): number | null {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function rentsDiffer(a: unknown, b: unknown): boolean {
  const left = numericRent(a);
  const right = numericRent(b);
  if (right == null) return false;
  if (left == null) return true;
  return Math.abs(left - right) >= 0.005;
}

export function formatMonthlyRent(value: unknown): string {
  const n = numericRent(value);
  if (n == null) return "—";
  return `$${n.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}/mo`;
}
